<template>
  <toggle-list :data="channelsList" :model="model" />
</template>

<script>
import ToggleList from '@/common/components/form/ToggleList'
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'UrlTrackingChannels',

  components: { ToggleList },

  props: {
    model: {
      type: Object,
      reuired: true
    }
  },

  computed: {
    channelsList() {
      return [
        {
          code: MessageTypeEnum.PUSH_WEB,
          name: this.$t('UrlTracking_Channels_WebPush')
        },
        {
          code: MessageTypeEnum.INBOX,
          name: this.$t('UrlTracking_Channels_Inbox')
        },
        {
          code: MessageTypeEnum.ON_SITE,
          name: this.$t('UrlTracking_Channels_Onsite')
        },
        {
          code: MessageTypeEnum.EMAIL,
          name: this.$t('UrlTracking_Channels_Email')
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/UrlTrackingChannels.vue